import styled from 'styled-components';
import {
    Card as ConstellationCard,
    // @ts-ignore
    Grid
} from '@zillow/constellation';

export const Card = styled(ConstellationCard)<{ isSmallScreen: boolean }>`
    height: ${({ isSmallScreen }) => (isSmallScreen ? '180px' : '200px')};
    display: flex;
    flex-direction: column;
    align-items: baseline;
`;

export const MarketPreviewContainer = styled(Grid)<{ loading: boolean; isSmallScreen: boolean }>`
    ${({ loading }) => (loading ? 'opacity: 50%;' : '')}
    padding-right: ${({ isSmallScreen }) => (isSmallScreen ? '' : '60px')};
    grid-template-columns: repeat(auto-fill, ${({ isSmallScreen }) =>
        isSmallScreen ? '140px' : 'minmax(170px, 1fr)'});
    grid-auto-flow: row;
`;

export const Link = styled.a`
    text-decoration: none;
`;
